<template>
	<div class="app-content">
		<template v-if="!$route.meta.external && $route.name != 'Home'">
			<RegisterHead v-if="$route.name == 'RegistrationPage'" />
			<!-- <HomePage v-else-if="$route.name == 'Home'" /> -->
			<HeadPage v-else />
		</template>
		<transition>
			<keep-alive include="Index">
				<router-view />
			</keep-alive>
		</transition>
		<!-- <template v-if="!$route.meta.external">
			<BottomPage />
		</template> -->
	</div>
</template>
<script>
	import RegisterHead from "@/components/RegisterHead/index.vue";
	import HomePage from "@/components/HomePage/index.vue";
	import HeadPage from "@/components/HeadPage/index.vue";
	import BottomPage from "@/components/BottomPage/index.vue";
	export default {
		components: {
			HeadPage,
			BottomPage,
			RegisterHead,
			HomePage
		},
		data() {
			return {}
		},
		methods:{
		}
	}
</script>
<style lang="scss">
	img {
		display: block;
	}

	div {
		box-sizing: border-box;
	}

	html,
	body,
	.app-content {
		margin: 0;
		padding: 0;
		background-color: #f9fafe;
	}

	// * {
	//   -moz-user-select: none;
	//   -webkit-user-select: none;
	//   -ms-user-select: none;
	//   -khtml-user-select: none;
	//   user-select: none;
	// }

	body {

		// scrollbar-arrow-color: #ffffff;
		/*三角箭头的颜色*/
		scrollbar-face-color: #1D78FF;
		/* 立体滚动条亮边的颜色 */
		scrollbar-highlight-color: #ddd;
		/* 滚动条的高亮颜色（左阴影？） */
		scrollbar-shadow-color: #ffffff;
		/* 立体滚动条阴影的颜色 */
		scrollbar-darkshadow-color: #ffffff;
		/* 立体滚动条外阴影的颜色 */
		scrollbar-track-color: #ffffff;
		/* 立体滚动条背景颜色 */
		scrollbar-base-color: #ffffff;
		/* 滚动条的基色 */
	}

	::-webkit-scrollbar {
		width: 8px;
		height: 6px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background-color: #D5D6DA;
	}

	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background-color: #ffffff;
		box-shadow: none;
	}

	/* 下面我们会解释这些 class 是做什么的 */
	.v-enter-active,
	.v-leave-active {
		transition: opacity 0s ease;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
	}
</style>